export default {
  data: () => ({

    canvasForms: null,
    rawData:  null,
    dataset: null,

    pieSectors: []
    
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {

    set_Gradients() {
      this.gmx_radialShadow()
      this.gmx_Color2Sets()
    },
  
  }
}